
const SmallCloseIcon = (props: { color?: string }) => {
    return (
        <svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Remove</title>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Web-Chat_Catalogue-01-Copy-5" transform="translate(-1114, -1485)" fill={props.color ?? "#FFFFFF"}>
                    <g id="Group-5" transform="translate(1040, 1481)">
                        <g id="Group-4" transform="translate(82.5, 12.5) rotate(-45) translate(-82.5, -12.5)translate(77, 7)">
                            <rect id="Rectangle-9" x="0" y="4.8125" width="11" height="1.375"></rect>
                            <polygon id="Rectangle-9-Copy" transform="translate(5.5, 5.5) rotate(90) translate(-5.5, -5.5)" points="-1.46013365e-13 4.8125 11 4.8125 11 6.1875 -1.46041268e-13 6.1875"></polygon>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default SmallCloseIcon